import { HttpErrorResponse } from '@angular/common/http';
import { ConfiguratorIntegrations } from '@models';
import { Action, createReducer, on } from '@ngrx/store';
import { GetIntegrationsFailure, GetIntegrationsRequest, GetIntegrationsSuccess } from './actions';

export interface State {
  data: ConfiguratorIntegrations | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const featureKey = 'integration';

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(GetIntegrationsFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(GetIntegrationsRequest, state => ({ ...state, error: null, loading: true })),
    on(GetIntegrationsSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
